import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navigation from "./components/navigation/navigation";
import useAuthCheck from "./hooks/useAuthCheck";
import Login from "./pages/Login";
import Projects from "./pages/projects/projects";
import Teams from "./pages/teams/teams";
import PrivateRoute from "./ui/PrivateRoute";
import PublicRoute from "./ui/PublicRoute";

function App() {
  const authChecked = useAuthCheck();

  return !authChecked ? (
    <div>Checking authentication....</div>
  ) : (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/teams"
          element={
            <PrivateRoute>
              <Navigation />
              <Teams />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <PrivateRoute>
              <Navigation />
              <Projects />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
